import { render, staticRenderFns } from "./CookieBanner.vue?vue&type=template&id=5a599acf&scoped=true"
import script from "./CookieBanner.vue?vue&type=script&lang=js"
export * from "./CookieBanner.vue?vue&type=script&lang=js"
import style0 from "./CookieBanner.vue?vue&type=style&index=0&id=5a599acf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a599acf",
  null
  
)

export default component.exports